import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IStoreType } from '../store-types/store-types';
import { MIHttpClientService } from 'src/app/shared/mi-http-client.service';
import { sortByField } from '../../shared/custom-rxjs-operators';

@Injectable({
  providedIn: 'root',
})
export class StoreTypeService {

  constructor(private miClient: MIHttpClientService) { }

  getStoreTypes(): Observable<IStoreType[]> {
    return this.miClient.get<IStoreType[]>('storeTypes').pipe(sortByField('storeType'));
  }

  getStoreType(id: number): Observable<any> {
    return this.miClient.get<IStoreType>('storeTypes/' + id);
  }

  createStoreType(item: IStoreType): Observable<any> {
    return this.miClient.post('storeTypes', item);
  }

  updateStoreType(item: any): Observable<any> {
    return this.miClient.post('storeTypes/' + item.id, item);
  }

  deleteStoreType(id: number): Observable<any> {
    return this.miClient.delete('storeTypes/' + id);
  }
}
